import styled from 'styled-components'

export const CellLongString = styled.span`
  word-break: break-all;
`
